import React from 'react';
import VidNetClient from './VidNetClient';
import { shuffleVideos } from '../utils';

const client = new VidNetClient();

export default function useVideoData() {
  const [clips, setClips] = React.useState(shuffleVideos(10));
  const [narrative, setNarrative] = React.useState([]);
  const [singleChannel, setSingleChannel] = React.useState(false);
  const [videoSequences, setVideoSequences] = React.useState([{ Initials: '', Sequence: [] }]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [sequenceIndex, setSequenceIndex] = React.useState(0);
  const [videoIndex, setVideoIndex] = React.useState(0);

  const end = clips === narrative;

  const context = {
    clips,
    setClips,
    narrative,
    setNarrative,
    done: end,
    singleChannel,
    setSingleChannel,
    videoSequences,
    setVideoSequences,
    isLoaded,
    setIsLoaded,
    sequenceIndex,
    setSequenceIndex: index => setSequenceIndex(index % videoSequences.length),
    videoIndex,
    setVideoIndex,
  };

  React.useEffect(() => {
    (async () => {
      const getVideoSequences = client.getVideoSequences();
      setVideoSequences(await getVideoSequences);
      setIsLoaded(true);
    })();
  }, []);

  return context;
}
